import { pulseLoginGeoPillHeartbeat, setLoginGeoPill } from '@/logic/geolocation/login-geo-pill-state';
import { LocationVerificationPillVisual } from '@/logic/geolocation/login-geo-types.types';

let inProgress = false;
let pendingLaunch: (() => void) | null = null;
const resolutionWaiters = new Set<(outcome: LocationVerificationPillVisual) => void>();

export const isLoginGeolocationBlocking = (): boolean => inProgress;

export const beginLoginGeolocation = (): void => {
    inProgress = true;
    setLoginGeoPill(LocationVerificationPillVisual.VERIFYING);
};

export const endLoginGeolocation = (outcome: LocationVerificationPillVisual): void => {
    if (!inProgress) {
        return;
    }

    inProgress = false;
    resolutionWaiters.forEach((resolve) => resolve(outcome));
    resolutionWaiters.clear();

    if (pendingLaunch) {
        const launch = pendingLaunch;
        pendingLaunch = null;
        launch();
        return;
    }

    pendingLaunch = null;
};

export const resetLoginGeolocationGate = (): void => {
    inProgress = false;
    pendingLaunch = null;
    resolutionWaiters.clear();
};

/**
 * When login GeoComply is verifying, queue the launch (last tap wins) and pulse the pill.
 * Otherwise runs the launch immediately.
 */
export const runGameLaunchWithLoginGeolocationGate = (launch: () => void): void => {
    if (!inProgress) {
        launch();
        return;
    }

    pendingLaunch = launch;
    pulseLoginGeoPillHeartbeat();
};

export const waitForLoginGeolocationResolution = (): Promise<LocationVerificationPillVisual | null> => {
    if (!inProgress) {
        return Promise.resolve(null);
    }

    return new Promise((resolve) => {
        const onResolve = (outcome: LocationVerificationPillVisual) => {
            resolutionWaiters.delete(onResolve);
            resolve(outcome);
        };
        resolutionWaiters.add(onResolve);
    });
};
